var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-view" }, [
    _c(
      "div",
      { staticClass: "main-content" },
      [
        _c("search-bar", {
          ref: "searchBar",
          attrs: {
            "config-module": "3300001",
            filter: _vm.searchConditions,
            "show-input-val": false,
            "ocr-tab": _vm.OCR_TAB_PENDING.code
          },
          on: {
            toQuery: _vm.toQuery,
            supplementaryInformation: _vm.supplementaryInformation,
            batchDelete: _vm.batchDelete,
            change: _vm.searchChange
          }
        }),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("intelligent-booking-table", {
              ref: "intelligentBookingTable",
              attrs: {
                "row-data": _vm.rowData,
                "config-module": "3300021",
                "tab-type": "tabPending"
              },
              on: {
                showDetails: function(e) {
                  return this$1.$emit("showDetails", e)
                },
                refresh: _vm.fetchData,
                changeSelected: _vm.changeSelected
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination-wrapper" },
          [
            _c("cargo-pagination", {
              attrs: {
                "config-module": "intelligent-tab-pending",
                total: _vm.searchConditions.total,
                page: _vm.searchConditions.pageNum,
                limit: _vm.searchConditions.pageSize
              },
              on: {
                "update:page": function($event) {
                  return _vm.$set(_vm.searchConditions, "pageNum", $event)
                },
                "update:limit": function($event) {
                  return _vm.$set(_vm.searchConditions, "pageSize", $event)
                },
                pagination: _vm.queryPageHandler
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }